export default __webpack_public_path__ + "static/media/doc1.eed8b3f9.svg";